<div class="grid grid-cols-12 gap-4 pb-4 px-4 h-full">
  <div class="col-span-12 min-[1400px]:col-span-3 bg-white rounded-lg mb-4 min-[1400px]:mb-0 h-full overflow-hidden">
    <app-input-solutions [diagnosisSessionId]="sessionId" />
  </div>
  <div class="col-span-12 min-[1400px]:col-span-9 rounded-lg available-solutions h-full overflow-hidden">
    <app-available-solutions [diagnosisSessionId]="sessionId" />
  </div>
</div>
